export default __webpack_public_path__ + "static/media/parse.a6a56d48.svg";